module.exports = __webpack_public_path__ + "img/bgc333.d6751886.png";